(function (process){
require('core-js/stable');

var angular = require('angular');
var app = angular.module('app', []);
var _ = require('lodash');

// https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padEnd
if (!String.prototype.padEnd) {
    String.prototype.padEnd = function padEnd(targetLength,padString) {
        targetLength = targetLength>>0; //floor if number or convert non-number to 0;
        padString = String((typeof padString !== 'undefined' ? padString : ' '));
        if (this.length > targetLength) {
            return String(this);
        }
        else {
            targetLength = targetLength-this.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength/padString.length); //append to original to ensure we are longer than needed
            }
            return String(this) + padString.slice(0,targetLength);
        }
    };
}

window.googleMapsAPIKEY = {"mapsApiKey":"AIzaSyDsj1nmsCSOA9-U1odURZBTqDmAmv3tH1Y"}.mapsApiKey;

// Node Modules
require('angular-animate');
require('angular-ui-router');
require('./libs/angular-ui-utils');
require('angular-aria');
require('angular-material');
require('ng-dialog');
require('angulartics');
require('./components/lr-touch');
require('./libs/angulartics-ga');

// Components
require('./components/cached-templates/templates');
require('./components/core/filters');
require('./components/core/utils');
require('./components/core/simple-dialog');
require('./components/core/slider-config');
require('./components/core/toggle-slider-draggable');
require('./components/main-menu');
require('./components/book-demo');
require('./components/events');
require('./components/events/mixpanel');


app.requires.push(
    'angulartics',
    'angulartics.google.analytics',
    'ngMaterial',
    'ngAnimate',
    'ui.router',
    'ui.mask',
    'listreports.core',
    'listreports.main-menu',
    'listreports.book-demo',
    'lr.touch',
    'ngDialog',
    'templates',
    'listreports.events',
    'listreports.events.mixpanel'
);


if(process.env.NODE_ENV !== 'production') {
    require('./components/events/console');
    app.requires.push('listreports.events.console');
}

app
    .controller('ApplicationController', [
        '$log',
        '$q',
        '$rootScope',
        '$scope',
        '$state',
        '$timeout',
        'ngDialog',
        '$utils',
        '$events',
        '$window',

        function($log, $q, $rootScope, $scope, $state, $timeout, ngDialog, $utils, $events, $window) {
            $scope.disableFullscreenLoader = true;
            $scope.backgroundStyle         = {'background-color': '#1E2B35'};
            $scope.hasTouchSupprt          = $utils.hasTouchSupprt();
            $scope.isMobile                = $(window).width() <= 600;
            $scope.windowHeight            = $(window).height();


            // $watch Functions

            // $scope Functions

            $rootScope.go = function(where) {
                $state.go(where);
            };

            function isIOS() {
                var deviceAgent = navigator.userAgent;
                var ios = deviceAgent.toLowerCase().match(/(iphone|ipod|ipad)/);

                return !!ios;
            }

            // Event Listeners
            $(window).on('resize', function() {
                $scope.$apply(function() {
                    $scope.isMobile = $(window).width() <= 600;
                    $scope.windowHeight = $(window).height();

                    console.log($scope.windowHeight);
                });
            });
        }
    ])

    .config([
        '$stateProvider',
        '$locationProvider',
        '$analyticsProvider',

        function($stateProvider, $locationProvider, $analyticsProvider) {
            $locationProvider.hashPrefix('!');
            $analyticsProvider.virtualPageviews(false);


            $stateProvider
                .state(
                    'four0four',
                    {
                        templateUrl: 'js/components/four0four/index.tmpl.html'
                    }
                )

                .state(
                    'book-demo',
                    {
                        url: '^/book-a-demo?path&campaign',
                        template: '<book-demo/>'
                    }
                )

                .state(
                    'main-menu',
                    {
                        url: '^/:userId',
                        templateUrl: 'js/components/main-menu/templates/main-menu.tmpl.html',
                        controller: 'MainMenuController'
                    }
                )

            ;

            $locationProvider.html5Mode({ enabled: true });
        }
    ])
;

}).call(this,require('_process'))
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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